import { render, staticRenderFns } from "./EmployeeFaceFormAdd.vue?vue&type=template&id=143f36c4"
import script from "./EmployeeFaceFormAdd.vue?vue&type=script&lang=js"
export * from "./EmployeeFaceFormAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports